import { render, staticRenderFns } from "./aliyun.vue?vue&type=template&id=1788fca3"
import script from "./aliyun.vue?vue&type=script&lang=js"
export * from "./aliyun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports